import React, { memo } from 'react';
import { useProjectId } from 'store/project';
import { Spinner } from 'components/core';
import { SingleProject } from 'components/project/single';
import { useProjectOnSingleView } from './useProjectOnSingleView';

const ProjectGeneralData = (): React.ReactElement => {
  const { project, loading } = useProjectOnSingleView(useProjectId());

  if (loading || !project) {
    return <Spinner reason='ProjectGeneralData loading || !project' />;
  }

  return <SingleProject {...project} />;
};

export const MemoProjectGeneralData = memo(ProjectGeneralData);
